import { render, staticRenderFns } from "./WorkNum.vue?vue&type=template&id=4b6c5057&"
import script from "./WorkNum.vue?vue&type=script&lang=js&"
export * from "./WorkNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports